export function resetPageRegisterNewPatientsFormData() {
    document.querySelectorAll('.register-new-patient__input input').forEach((element) => { element.value = ''; });
}

export function checkPageRegisterNewPatientsFormData() {
    let firstNameDom = document.querySelectorAll('.register-new-patient__input input')[0];
    let lastNameDom = document.querySelectorAll('.register-new-patient__input input')[1];
    let dobDom = document.getElementById('dobDatepicker');

    if (!firstNameDom.value || firstNameDom.value.length === 0) return false;
    if (!lastNameDom.value || lastNameDom.value.length === 0) return false;
    if (!dobDom || dobDom.value.length === 0) return false;
    return true;
}